import '../autoload/_scrollspy'

export default function initMenu() {
  $('.menu-button').on('click', function (){
    $(this).toggleClass('menu-button--active')
    $('.mobile-nav').slideToggle()
  })

  $('#menu-menu-1 a').on('click', function (event) {
    let target = $(this).attr('href');
    if (target.indexOf('#') >= 0) {
      event.preventDefault()
      $('html, body').animate({ scrollTop: $(target).offset().top - 70 }, 1000);
    }

    if ($(this).parents('.menu-nav').length > 0) {
      $('.menu-button').removeClass('menu-button--active')
      $('.mobile-nav').slideUp()
      console.log('Link clicked in mobile-menu')
    }
  })

  $('#menu-menu-1').scrollspy({offset: -80});
}



// WEBPACK FOOTER //
// ./scripts/components/menu.js